import { mapToBreakpoints } from '@koaly/mixins';

const getHalign = (values, reverse) => {
    return mapToBreakpoints(values, (value) => {
        let rule = '';
        switch (value) {
            case 'left':
                rule = reverse ? 'flex-end' : 'flex-start';
                break;
            case 'right':
                rule = reverse ? 'flex-start' : 'flex-end';
                break;
            case 'center':
                rule = 'center';
                break;
            case 'justify-center':
                rule = 'space-around';
                break;
            case 'justify':
                rule = 'space-between';
                break;
            default:
                throw new Error(
                // eslint-disable-next-line max-len
                `grid: halign must be one of "left", "right", "center", "justify-center" or "justify". Got "${String(value)}"`);
        }
        return `justify-content: ${rule};`;
    });
};

export { getHalign };
//# sourceMappingURL=getHalign.js.map
